import { EventEmitter, Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder,  } from '@aspnet/signalr';
import { Message } from '../../../interfaces/patient-services/message';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  messageReceived = new EventEmitter<Message>();
  connectionEstablished = new EventEmitter<Boolean>();
  public chatbox:boolean=true;
  private connectionIsEstablished = false;
  private _hubConnection: HubConnection;
 
  constructor() {
    // this.createConnection();
    // this.registerOnServerEvents();
    // this.startConnection();
  }
  startConnect(){
    // this.createConnection();
    // this.registerOnServerEvents();
    // this.startConnection();
  }
  sendMessage(message: Message) {
    this._hubConnection.invoke('NewMessage', message);
  }

  private createConnection() {

    var url=environment.apiUrl;
    url=url.replace("/api","/MessageHub");
    //alert(url) 
    // alert(window.location.href + 'MessageHub');
    this._hubConnection = new HubConnectionBuilder()  
    .withUrl(url) 
     .build();
  }

  private startConnection(): void {
    //console.error("connection start");

    this._hubConnection
      .start()
      .then(() => {
        this.connectionIsEstablished = true;
        //console.log('Hub connection started');
        this.connectionEstablished.emit(true);
        // console.log('connection ID: ')
        // console.log(this._hubConnection.invoke("GetConnectionID"))
        // console.log('User Identifier: ')
        // console.log(this._hubConnection.invoke("GetUserIdentifier"))
        // console.log('User Name: ')
        // console.log(this._hubConnection.invoke("GetUserName"))
      })
      .catch(err => {
        //console.log('Error while establishing connection, retrying...'+err);
        setTimeout(() => { this.startConnection(); }, 5000);
      });
  }

  private registerOnServerEvents(): void {
    this._hubConnection.on('MessageReceived', (data: any) => {
      this.messageReceived.emit(data);
    });
  }
}
